// try auto detect, but what if rotate mobile?
// const isPC = window.innerWidth > window.innerHeight;
const isPC = false;
const resolution = isPC ? {width:1920, height:1080} : {width:540, height:900};
const folder = isPC ? "1920x1080" : "540x760";
const path = "res/" + folder;
module.exports = {
    isPC: isPC,
    folder: folder,
    path: path,
    resolution: resolution,
    screen_ratio: resolution.width / resolution.height,
    loadscreen: {
        image: path + "/loadscreen.jpg",
        loadbar:{
            position: isPC ? {x:668, y:902} : {x:83, y:668},
            image: path + "/loadbar.png"
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 19
// module chunks = 0